import { useState } from "react";
import axios from "axios";

export default function AdminAddProduct() {
  const [form, setForm] = useState({
    name: "",
    description: "",
    place: "",
    features: "",
  });
  const [image, setImage] = useState(null);

 const submit = async () => {
  const data = new FormData();
  data.append("name", form.name);
  data.append("description", form.description);
  data.append("place", form.place);
  data.append("features", form.features);
  if (image) data.append("image", image);

  const token = localStorage.getItem("adminToken");

  try {
    const res = await axios.post(
      "https://haaterkaj-backend-1.onrender.com/api/admin/add-product",
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    if (res.data.success) alert("✅ Product Added Successfully!");
    else alert(res.data.message);
  } catch (error) {
    console.log(error.response?.data || error.message);
    alert("❌ Upload Failed");
  }
};

  return (
    <div className="p-6 max-w-xl mx-auto">
      <h2 className="text-xl font-bold mb-4">Add New Product</h2>

      {["name", "description", "place", "features"].map((field) => (
        <input
          key={field}
          className="border p-2 w-full mb-3"
          placeholder={field.toUpperCase()}
          onChange={(e) => setForm({ ...form, [field]: e.target.value })}
        />
      ))}

      {/* IMAGE UPLOAD FIELD */}
      <input
        type="file"
        className="border p-2 w-full mb-3"
        onChange={(e) => setImage(e.target.files[0])}
      />

      {/* PREVIEW IMAGE */}
      {image && (
        <img
          src={URL.createObjectURL(image)}
          alt="preview"
          className="h-40 object-cover rounded mb-3"
        />
      )}

      <button onClick={submit} className="bg-green-600 text-white px-4 py-2 rounded">
        Add Product
      </button>
    </div>
  );
}
